module.exports = __webpack_public_path__ + "img/hcc_hustletokens.8076e3c.png";